import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import macinstallericon from "../../../../assets/images/blogs/pp23/macinstallericon.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  macinstallericon,
  React
};